import { ACTIONS as logoutActions } from 'actions/logout';
import { ACTIONS } from 'actions/teacher-streams';
import { errors } from 'redux-rest-reducer';

const initialState = {
  teacherStreams: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SET_TEACHER_STREAMS: {
      return {
        ...state,
        ...payload,
      };
    }
    case ACTIONS.CLEAR_TEACHER_STREAMS:
    case logoutActions.POST_SUCCESS:
    case errors[401]:
      return initialState;
    default: {
      return state;
    }
  }
}
